export default __webpack_public_path__ + "09650a0730530fe9f1cd8140a32a6e4d.png";